import React from 'react';
import { LYT_INFO } from '../config/constants';

export default function TermsPage({ darkMode }) {
  const bg = darkMode ? '#0d1b2a' : '#ffffff';
  const text = darkMode ? '#e2e8f0' : '#334155';
  const heading = darkMode ? '#ffffff' : '#0f172a';
  const accent = darkMode ? '#c850c0' : '#0077B6';
  const cardBg = darkMode ? '#112240' : '#f8fafc';
  const border = darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.08)';

  const Section = ({ title, children }) => (
    <div style={{ marginBottom: 32 }}>
      <h2 style={{ color: heading, fontSize: 20, fontWeight: 600, marginBottom: 12 }}>{title}</h2>
      <div style={{ color: text, fontSize: 15, lineHeight: 1.7 }}>{children}</div>
    </div>
  );

  return (
    <div style={{ backgroundColor: bg, minHeight: '80vh', padding: '48px 20px' }}>
      <div style={{ maxWidth: 800, margin: '0 auto' }}>
        <h1 style={{ color: heading, fontSize: 32, fontWeight: 700, marginBottom: 8 }}>Terms and Conditions</h1>
        <p style={{ color: accent, fontSize: 14, marginBottom: 40 }}>Last updated: March 4, 2026</p>

        <div style={{ background: cardBg, border: `1px solid ${border}`, borderRadius: 12, padding: 32 }}>
          <Section title="1. Agreement to Terms">
            <p>By accessing or using the {LYT_INFO.name} website and platform at lytcomm.com ("Service"), you agree to be bound by these Terms and Conditions. If you do not agree, do not use the Service.</p>
          </Section>

          <Section title="2. Description of Service">
            <p>{LYT_INFO.name} provides a workforce management platform for fiber optic construction operations. The Service includes project tracking, employee and contractor management, production reporting, billing, compliance monitoring, and related operational tools.</p>
          </Section>

          <Section title="3. User Accounts">
            <p>Access to the platform requires an invitation from {LYT_INFO.name} management. You are responsible for maintaining the confidentiality of your login credentials and for all activities under your account. Notify us immediately of any unauthorized use.</p>
          </Section>

          <Section title="4. Acceptable Use">
            <p>You agree to use the Service only for its intended business purposes. You may not:</p>
            <ul style={{ margin: '8px 0', paddingLeft: 24 }}>
              <li>Share login credentials with unauthorized persons</li>
              <li>Attempt to access data or systems beyond your authorized role</li>
              <li>Upload false or misleading production reports or documentation</li>
              <li>Use the platform for any unlawful purpose</li>
              <li>Interfere with or disrupt the Service or its infrastructure</li>
            </ul>
          </Section>

          <Section title="5. SMS Messaging Terms">
            <p><strong>Program Name:</strong> {LYT_INFO.name} Admin Alerts</p>
            <p style={{ marginTop: 8 }}><strong>Program Description:</strong> Operational notifications for company administrators including payment status updates, billing alerts, compliance reminders, and project notifications.</p>
            <p style={{ marginTop: 8 }}><strong>Message Frequency:</strong> Message frequency varies based on business activity. Typically 1-10 messages per month.</p>
            <p style={{ marginTop: 8 }}><strong>Message and Data Rates:</strong> Message and data rates may apply. Check with your wireless carrier for details about your plan.</p>
            <p style={{ marginTop: 8 }}><strong>Opt-In:</strong> Consent to receive SMS is obtained during internal administrator setup. You may also opt in by texting <strong>START</strong> to our messaging number.</p>
            <p style={{ marginTop: 8 }}><strong>Opt-Out:</strong> You can opt out at any time by texting <strong>STOP</strong> to any message from us. You will receive a confirmation message and no further SMS messages will be sent.</p>
            <p style={{ marginTop: 8 }}><strong>Help:</strong> For support, text <strong>HELP</strong> to any message from us, or contact us at {LYT_INFO.email} or {LYT_INFO.phone}.</p>
            <p style={{ marginTop: 8 }}>Your phone number and opt-in data will not be shared with third parties for marketing or promotional purposes.</p>
          </Section>

          <Section title="6. Intellectual Property">
            <p>All content, features, and functionality of the Service are owned by {LYT_INFO.name} and are protected by applicable intellectual property laws. You may not copy, modify, distribute, or create derivative works from the Service without written permission.</p>
          </Section>

          <Section title="7. Data and Content">
            <p>You retain ownership of data you submit to the platform (production reports, photos, documentation). By submitting content, you grant {LYT_INFO.name} a license to use, store, and process that data for business operations and reporting purposes.</p>
          </Section>

          <Section title="8. Confidentiality">
            <p>Information accessed through the platform — including rate cards, client data, project details, and financial information — is confidential. You agree not to disclose such information to unauthorized parties, consistent with any NDA or employment agreement in effect.</p>
          </Section>

          <Section title="9. Limitation of Liability">
            <p>{LYT_INFO.name} provides the Service "as is" without warranties of any kind. We are not liable for any indirect, incidental, or consequential damages arising from your use of the Service. Our total liability shall not exceed the amount paid by you, if any, for access to the Service.</p>
          </Section>

          <Section title="10. Termination">
            <p>We may suspend or terminate your access to the Service at any time, with or without cause. Upon termination, your right to use the Service ceases immediately. Provisions that by their nature should survive termination (confidentiality, limitation of liability) will remain in effect.</p>
          </Section>

          <Section title="11. Governing Law">
            <p>These Terms are governed by the laws of the State of Texas. Any disputes shall be resolved in the courts of Harris County, Texas.</p>
          </Section>

          <Section title="12. Changes to Terms">
            <p>We may update these Terms from time to time. Continued use of the Service after changes constitutes acceptance of the updated Terms.</p>
          </Section>

          <Section title="13. Contact Us">
            <p>Questions about these Terms? Contact us at:</p>
            <p style={{ marginTop: 8 }}>
              {LYT_INFO.name}<br />
              {LYT_INFO.address}<br />
              {LYT_INFO.city}, {LYT_INFO.state} {LYT_INFO.zip}<br />
              {LYT_INFO.phone}<br />
              <a href={`mailto:${LYT_INFO.email}`} style={{ color: accent }}>{LYT_INFO.email}</a>
            </p>
          </Section>
        </div>
      </div>
    </div>
  );
}
